module.exports = __webpack_public_path__ + "img/clapboard-bottom.039e3390.svg";